document.addEventListener('DOMContentLoaded', function () {
  let progressInterval;
  let currentProgress = 0;
  let currentDuration = 5000;
  let isCurrentSlidePaused = false;
  let pausedProgress = 0;
  let firstSlideRemoved = false;

  const heroSwiper = new Swiper('.hero-swiper', {
    loop: true,
    autoplay: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 800,
    allowTouchMove: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    on: {
      init: function () {
        console.log('Swiper initialized');

        // Check if there's only one slide
        const slideCount = this.slides.length;
        console.log('Number of slides:', slideCount);

        if (slideCount === 1) {
          // Hide navigation and progress elements for single slide
          document.querySelector('.hero-bottom-nav')?.classList.add('hero-bottom-nav--hidden');

          // Set text color for the single slide
          const activeSlide = document.querySelector('.swiper-slide-active');
          if (activeSlide) {
            const defaultColor = activeSlide.dataset.defaultColor || 'white';
            activeSlide.classList.remove('BB-hero-text-white', 'BB-hero-text-black');
            activeSlide.classList.add(`BB-hero-text-${defaultColor}`);
            updateParentTextColor();
          }

          // Load and play video for single slide
          setTimeout(() => {
            loadAndPlayActiveSlideVideo();
          }, 50);
        } else if (slideCount > 1) {
          resetProgress();

          // Set initial text color immediately
          const activeSlide = document.querySelector('.swiper-slide-active');
          if (activeSlide) {
            const defaultColor = activeSlide.dataset.defaultColor || 'white';
            activeSlide.classList.remove('BB-hero-text-white', 'BB-hero-text-black');
            activeSlide.classList.add(`BB-hero-text-${defaultColor}`);
            updateParentTextColor();
          }

          setTimeout(() => {
            startProgress();
            // Load video for first slide
            loadAndPlayActiveSlideVideo();
          }, 50);
        }
      },
      slideChangeTransitionStart: function () {
        console.log('Slide change START (any navigation type)');
        clearInterval(progressInterval);
        progressInterval = null;
        pauseAllVideos();
        isCurrentSlidePaused = false;
        pausedProgress = 0;
        resetProgress();
        updatePlayPauseButton();

        // IMMEDIATELY update text color for the next slide (even during transition)
        setTimeout(() => {
          const activeSlide = document.querySelector('.swiper-slide-active');
          if (activeSlide) {
            const defaultColor = activeSlide.dataset.defaultColor || 'white';
            activeSlide.classList.remove('BB-hero-text-white', 'BB-hero-text-black');
            activeSlide.classList.add(`BB-hero-text-${defaultColor}`);
            updateParentTextColor();
          }
        }, 0);
      },
      slideChangeTransitionEnd: function () {
        console.log('Slide change END (any navigation type) - starting progress');

        // Initialize text color for the new slide IMMEDIATELY (no timeout)
        const activeSlide = document.querySelector('.swiper-slide-active');
        if (activeSlide) {
          const defaultColor = activeSlide.dataset.defaultColor || 'white';
          activeSlide.classList.remove('BB-hero-text-white', 'BB-hero-text-black');
          activeSlide.classList.add(`BB-hero-text-${defaultColor}`);

          // Update parent container immediately
          updateParentTextColor();
        }

        // Start progress with minimal delay
        setTimeout(() => {
          startProgress();
        }, 50);
      },
      touchStart: function () {
        console.log('Touch/swipe started');
      },
      touchEnd: function () {
        console.log('Touch/swipe ended');
      },
      slideChange: function () {
        console.log('Slide changed (catches all types)');
      },
    },
  });

  // Play/Pause functionality
  const playPauseBtn = document.getElementById('playPauseBtn');
  const heroProgress = document.getElementById('heroProgress');

  if (playPauseBtn) {
    playPauseBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isCurrentSlidePaused) {
        resumeSlide();
      } else {
        pauseSlide();
      }
    });
  }

  // Helper function to get active video (mobile or desktop)
  function getActiveVideo() {
    const activeSlide = document.querySelector('.swiper-slide-active');
    if (!activeSlide) return null;

    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      // Try mobile video first on mobile
      return (
        activeSlide.querySelector('.hero-slide__video--mobile') ||
        activeSlide.querySelector('.hero-slide__video--desktop')
      );
    } else {
      // On desktop, use desktop video
      return activeSlide.querySelector('.hero-slide__video--desktop');
    }
  }

  function pauseSlide() {
    isCurrentSlidePaused = true;
    pausedProgress = currentProgress;
    clearInterval(progressInterval);

    // Pause active video (mobile or desktop)
    const activeVideo = getActiveVideo();
    if (activeVideo) {
      activeVideo.pause();
    }

    updatePlayPauseButton();
  }

  function resumeSlide() {
    isCurrentSlidePaused = false;
    currentProgress = pausedProgress; // Continue from paused position

    // Resume active video (mobile or desktop)
    const activeVideo = getActiveVideo();
    if (activeVideo) {
      activeVideo.play().catch(() => {});
    }

    updatePlayPauseButton();

    // Clear any existing interval before starting new one
    clearInterval(progressInterval);
    progressInterval = null;

    // Start progress immediately without delay when resuming
    startProgressFromCurrent();
  }

  function startProgressFromCurrent() {
    if (isCurrentSlidePaused) return;

    const progressFill = document.querySelector('.hero-progress__fill');
    if (!progressFill) return;

    const circumference = 157.08;

    // Set current position immediately
    const currentProgressPercent = (currentProgress / currentDuration) * 100;
    const currentOffset = circumference - (currentProgressPercent / 100) * circumference;

    progressFill.style.transition = 'stroke-dashoffset 0.1s linear';
    progressFill.style.strokeDashoffset = currentOffset;

    // Start interval immediately
    progressInterval = setInterval(() => {
      if (isCurrentSlidePaused) {
        clearInterval(progressInterval);
        progressInterval = null;
        return;
      }

      currentProgress += 100;
      const progress = (currentProgress / currentDuration) * 100;
      const offset = circumference - (progress / 100) * circumference;

      progressFill.style.strokeDashoffset = offset;

      // Update text color based on time
      updateTextColorBasedOnTime();

      if (currentProgress >= currentDuration) {
        clearInterval(progressInterval);
        progressInterval = null;
        if (heroSwiper.slides.length > 1) {
          currentProgress = 0;
          pausedProgress = 0;
          heroSwiper.slideNext();
        }
      }
    }, 100);
  }

  function updatePlayPauseButton() {
    const playPauseBtn = document.getElementById('playPauseBtn');
    if (isCurrentSlidePaused) {
      heroProgress.classList.remove('is-playing');
      if (playPauseBtn) playPauseBtn.setAttribute('aria-label', 'Play slideshow');
    } else {
      heroProgress.classList.add('is-playing');
      if (playPauseBtn) playPauseBtn.setAttribute('aria-label', 'Pause slideshow');
    }
  }

  // Update slide accessibility - add inert to non-active slides
  function updateSlideAccessibility() {
    const slides = document.querySelectorAll('.BB-hero-slide');
    slides.forEach((slide) => {
      if (slide.classList.contains('swiper-slide-active')) {
        slide.removeAttribute('inert');
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.setAttribute('inert', '');
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // Call on init and slide change
  setTimeout(updateSlideAccessibility, 100);
  if (heroSwiper) {
    heroSwiper.on('slideChangeTransitionEnd', updateSlideAccessibility);
  }

  function pauseAllVideos() {
    // Pause all video types (desktop and mobile)
    document.querySelectorAll('.hero-slide__video--desktop, .hero-slide__video--mobile').forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });
  }

  function playActiveSlideVideo() {
    const activeVideo = getActiveVideo();
    if (activeVideo && !isCurrentSlidePaused) {
      // Only reset if truly starting fresh
      if (currentProgress === 0) {
        activeVideo.currentTime = 0;
      }

      activeVideo.removeAttribute('loop');

      // Remove any existing event listeners first
      activeVideo.removeEventListener('ended', handleVideoEnd);
      activeVideo.addEventListener('ended', handleVideoEnd);

      activeVideo.play().catch((e) => console.log('Video play failed:', e));
    }
  }

  function handleVideoEnd() {
    console.log('Video ended, moving to next slide');
    if (heroSwiper.slides.length > 1) {
      clearInterval(progressInterval);
      progressInterval = null;
      currentProgress = 0;
      pausedProgress = 0;
      heroSwiper.slideNext();
    }
  }

  function getVideoDuration(video) {
    return new Promise((resolve) => {
      if (video.readyState >= 1) {
        resolve(video.duration * 1000);
      } else {
        video.addEventListener(
          'loadedmetadata',
          () => {
            resolve(video.duration * 1000);
          },
          { once: true }
        );
      }
    });
  }

  function resetProgress() {
    clearInterval(progressInterval);
    currentProgress = 0;
    pausedProgress = 0;

    const progressFill = document.querySelector('.hero-progress__fill');
    if (progressFill) {
      progressFill.style.transition = 'none';
      progressFill.style.strokeDasharray = 157.08;
      progressFill.style.strokeDashoffset = 157.08;
      // Force immediate update
      progressFill.offsetHeight;
    }
  }

  async function startProgress() {
    // Prevent multiple calls
    if (isCurrentSlidePaused || progressInterval) return;

    const activeSlide = document.querySelector('.swiper-slide-active');
    if (!activeSlide) return;

    const activeVideo = getActiveVideo(); // Use helper function

    // Determine duration
    if (activeVideo) {
      try {
        const videoDuration = await getVideoDuration(activeVideo);
        currentDuration = videoDuration;
        console.log('Using video duration:', videoDuration, 'ms');
      } catch (error) {
        console.log('Error getting video duration, using slide setting');
        const durationValue = activeSlide.dataset.duration;
        currentDuration = parseInt(durationValue) || 5000;
      }
    } else {
      const durationValue = activeSlide.dataset.duration;
      currentDuration = parseInt(durationValue) || 5000;
    }

    // Reset if fresh start
    if (pausedProgress === 0) {
      currentProgress = 0;
    }

    const progressFill = document.querySelector('.hero-progress__fill');
    if (!progressFill) return;

    // Set initial state without any animation
    const circumference = 157.08;
    const initialProgress = (currentProgress / currentDuration) * 100;
    const initialOffset = circumference - (initialProgress / 100) * circumference;

    progressFill.style.transition = 'none';
    progressFill.style.strokeDasharray = circumference;
    progressFill.style.strokeDashoffset = initialOffset;
    progressFill.offsetHeight;

    // Start video immediately (mobile or desktop)
    if (activeVideo) {
      playActiveSlideVideo();
    }

    // Start progress after very short delay to ensure video has started
    setTimeout(() => {
      if (!isCurrentSlidePaused && !progressInterval) {
        progressFill.style.transition = 'stroke-dashoffset 0.1s linear';

        progressInterval = setInterval(() => {
          if (isCurrentSlidePaused) {
            clearInterval(progressInterval);
            progressInterval = null;
            return;
          }

          currentProgress += 100;
          const progress = (currentProgress / currentDuration) * 100;
          const offset = circumference - (progress / 100) * circumference;

          progressFill.style.strokeDashoffset = offset;

          // Update text color based on time
          updateTextColorBasedOnTime();

          if (currentProgress >= currentDuration) {
            clearInterval(progressInterval);
            progressInterval = null;
            if (heroSwiper.slides.length > 1) {
              currentProgress = 0;
              pausedProgress = 0;
              heroSwiper.slideNext();
            }
          }
        }, 100);
      }
    }, 50);
  }

  // Handle ALL types of navigation (arrows, pagination, swipe, touch)
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.swiper-button-next') ||
      e.target.closest('.swiper-button-prev') ||
      e.target.closest('.swiper-pagination-bullet')
    ) {
      // Reset and prepare for new slide
      clearInterval(progressInterval);
      progressInterval = null;
      pauseAllVideos();
      currentProgress = 0;
      pausedProgress = 0;
      isCurrentSlidePaused = false;
    }
  });

  // Handle window resize - supports video switching
  let resizeTimeout;
  let lastWidth = window.innerWidth;

  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;

    // Only check width changes, ignore height changes
    if (Math.abs(currentWidth - lastWidth) > 50) {
      // Clear previous timeout
      clearTimeout(resizeTimeout);

      // Debounce resize events to avoid triggering on minor mobile viewport changes
      resizeTimeout = setTimeout(() => {
        console.log('Resize detected - going to first slide');

        // Pause all videos
        pauseAllVideos();

        // Stop current progress
        clearInterval(progressInterval);
        progressInterval = null;
        currentProgress = 0;
        pausedProgress = 0;

        // Go to first slide (index 0)
        heroSwiper.slideToLoop(0, 0); // slideToLoop(index, speed)

        // Wait for slide transition, then load and play video
        setTimeout(() => {
          loadAndPlayActiveSlideVideo();

          // Restart progress if not manually paused
          if (!isCurrentSlidePaused) {
            startProgress();
          }
        }, 100);

        // Update last known width
        lastWidth = currentWidth;
      }, 300); // 300ms debounce
    }
  });
  function parseTimeRanges(rangeString) {
    if (!rangeString || rangeString.trim() === '') return [];

    return rangeString
      .split(',')
      .map((range) => {
        const [start, end] = range
          .trim()
          .split('-')
          .map((num) => parseFloat(num.trim()));
        return { start: start * 1000, end: end * 1000 }; // Convert to milliseconds
      })
      .filter((range) => !isNaN(range.start) && !isNaN(range.end));
  }

  function updateTextColorBasedOnTime() {
    const activeSlide = document.querySelector('.swiper-slide-active');
    if (!activeSlide) return;

    const textMode = activeSlide.dataset.textMode;

    if (textMode !== 'timed') {
      return;
    }

    const whiteRanges = parseTimeRanges(activeSlide.dataset.whiteRanges);
    const blackRanges = parseTimeRanges(activeSlide.dataset.blackRanges);
    const defaultColor = activeSlide.dataset.defaultColor || 'white';

    // Convert current progress from milliseconds to seconds for comparison
    const currentTimeInSeconds = currentProgress / 1000;

    // Determine current color based on progress
    let shouldBeWhite = defaultColor === 'white';
    let shouldBeBlack = defaultColor === 'black';

    // Check white ranges
    for (const range of whiteRanges) {
      const startSeconds = range.start / 1000;
      const endSeconds = range.end / 1000;

      if (currentTimeInSeconds >= startSeconds && currentTimeInSeconds <= endSeconds) {
        shouldBeWhite = true;
        shouldBeBlack = false;
        break;
      }
    }

    // Check black ranges (black takes priority over white if both match)
    for (const range of blackRanges) {
      const startSeconds = range.start / 1000;
      const endSeconds = range.end / 1000;

      if (currentTimeInSeconds >= startSeconds && currentTimeInSeconds <= endSeconds) {
        shouldBeBlack = true;
        shouldBeWhite = false;
        break;
      }
    }

    // Apply the color to the entire slide
    activeSlide.classList.remove('BB-hero-text-white', 'BB-hero-text-black');

    if (shouldBeWhite) {
      activeSlide.classList.add('BB-hero-text-white');
    } else if (shouldBeBlack) {
      activeSlide.classList.add('BB-hero-text-black');
    }

    // Update parent container with same color class
    updateParentTextColor();
  }

  function updateParentTextColor() {
    const activeSlide = document.querySelector('.swiper-slide-active');
    const heroSlider = document.querySelector('.BB-hero-slider');
    const header = document.querySelector('.header');

    if (!activeSlide || !heroSlider) return;

    // Remove existing text color classes from both elements
    heroSlider.classList.remove('BB-hero-text-white', 'BB-hero-text-black');
    if (header) {
      header.classList.remove('BB-hero-text-white', 'BB-hero-text-black');
    }

    // Check which text color class the active slide has
    if (activeSlide.classList.contains('BB-hero-text-white')) {
      heroSlider.classList.add('BB-hero-text-white');
      if (header) {
        header.classList.add('BB-hero-text-white');
        console.log('Added BB-hero-text-white to header and slider');
      }
    } else if (activeSlide.classList.contains('BB-hero-text-black')) {
      heroSlider.classList.add('BB-hero-text-black');
      if (header) {
        header.classList.add('BB-hero-text-black');
        console.log('Added BB-hero-text-black to header and slider');
      }
    }
  }

  // Video Popup Functionality
  function initVideoPopup() {
    console.log('Initializing video popup');

    const videoPopup = document.getElementById('heroVideoPopup');
    const popupVideo = document.getElementById('heroPopupVideo');
    const closeBtn = document.getElementById('closeVideoPopup');
    const overlay = document.querySelector('.hero-video-popup__overlay');

    if (!videoPopup || !popupVideo) {
      console.error('Video popup elements not found');
      return;
    }

    // Open video popup
    function openVideoPopup(videoUrl, mobileVideoUrl) {
      console.log('Opening video popup');

      // Determine which video to use
      const isMobile = window.innerWidth <= 768;
      const finalVideoUrl = isMobile && mobileVideoUrl ? mobileVideoUrl : videoUrl;

      if (!finalVideoUrl || finalVideoUrl === '') {
        console.error('No video URL provided');
        return;
      }

      // Set video source
      popupVideo.innerHTML = `<source src="${finalVideoUrl}" type="video/mp4">`;
      popupVideo.load();

      // Show popup with overlay
      videoPopup.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      // Animate in
      setTimeout(() => {
        videoPopup.classList.add('active');
      }, 10);

      // Play video after animation
      setTimeout(() => {
        popupVideo.play().catch((e) => console.log('Video play failed:', e));
      }, 300);

      // Pause hero slider
      if (progressInterval) {
        clearInterval(progressInterval);
        progressInterval = null;
        isCurrentSlidePaused = true;
        updatePlayPauseButton();
      }
    }

    // Close video popup
    function closeVideoPopup(e) {
      console.log('Closing video popup');

      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      videoPopup.classList.remove('active');

      // Hide popup after animation
      setTimeout(() => {
        videoPopup.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);

      // Stop and reset video
      popupVideo.pause();
      popupVideo.currentTime = 0;
      popupVideo.innerHTML = '';

      // Resume hero slider if it was paused
      if (isCurrentSlidePaused) {
        isCurrentSlidePaused = false;
        startProgress();
        updatePlayPauseButton();
      }
    }

    // Event listeners for secondary buttons
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.hero-video-trigger');
      if (trigger) {
        console.log('Video trigger found:', trigger);

        if (trigger.dataset.hasVideo === 'true') {
          e.preventDefault();
          e.stopPropagation();
          const videoUrl = trigger.dataset.videoUrl;
          const mobileVideoUrl = trigger.dataset.mobileVideoUrl;
          openVideoPopup(videoUrl, mobileVideoUrl);
        }
      }
    });

    // Close popup events
    if (closeBtn) {
      closeBtn.addEventListener('click', closeVideoPopup);
    }

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          closeVideoPopup(e);
        }
      });
    }

    videoPopup.addEventListener('click', function (e) {
      if (e.target === videoPopup) {
        closeVideoPopup(e);
      }
    });

    // Prevent clicks on video content from closing popup
    const videoContainer = document.querySelector('.hero-video-popup__container');
    if (videoContainer) {
      videoContainer.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && videoPopup.classList.contains('active')) {
        closeVideoPopup(e);
      }
    });
  }

  // Initialize video popup after a short delay
  setTimeout(() => {
    initVideoPopup();
  }, 500);

  function loadAndPlayActiveSlideVideo() {
    const activeSlide = document.querySelector('.swiper-slide-active');
    if (!activeSlide) return;

    const isMobile = window.innerWidth <= 768;

    // Check if there's only one slide - if so, enable video looping
    const slideCount = heroSwiper.slides.length;
    const shouldLoop = slideCount === 1;

    // Desktop video
    const desktopVideo = activeSlide.querySelector('.hero-slide__video--desktop');
    // Mobile video
    const mobileVideo = activeSlide.querySelector('.hero-slide__video--mobile');
    // Image
    const image = activeSlide.querySelector('.hero-slide__image');

    if (isMobile && mobileVideo) {
      // Set loop attribute for single slide
      if (shouldLoop) {
        mobileVideo.setAttribute('loop', '');
      } else {
        mobileVideo.removeAttribute('loop');
      }

      // Only load/play mobile video on mobile
      const hasSource = mobileVideo.querySelector('source');
      if (!hasSource) {
        const src = mobileVideo.getAttribute('data-src');
        if (src) {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          mobileVideo.appendChild(source);
          mobileVideo.load();
          mobileVideo.play().catch(() => {});
          //if (image) image.remove();
        }
      } else {
        if (mobileVideo.paused) {
          mobileVideo.play().catch(() => {});
          //if (image) image.remove();
        }
      }
      // Pause desktop video if present
      if (desktopVideo) desktopVideo.pause();
    } else if (desktopVideo) {
      // Set loop attribute for single slide
      if (shouldLoop) {
        desktopVideo.setAttribute('loop', '');
      } else {
        desktopVideo.removeAttribute('loop');
      }

      // Only load/play desktop video on desktop
      const hasSource = desktopVideo.querySelector('source');
      if (!hasSource) {
        const src = desktopVideo.getAttribute('data-src');
        if (src) {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          desktopVideo.appendChild(source);
          desktopVideo.load();
          desktopVideo.play().catch(() => {});
          //if (image) image.remove();
        }
      } else {
        if (desktopVideo.paused) {
          desktopVideo.play().catch(() => {});
          //if (image) image.remove();
        }
      }
      // Pause mobile video if present
      if (mobileVideo) mobileVideo.pause();
    }
  }

  // On every slide change, run for the new active slide
  heroSwiper.on('slideChangeTransitionEnd', function () {
    loadAndPlayActiveSlideVideo();
  });
});
